import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import styles, { global } from './styles';
import useScreenWidth from 'utils/useScreenWidth';
import ReactPlayer from 'react-player'

const UltralabsVideo = ({ block }) => {
    const [navbar, setNavbar] = useState(false);
    const [navbarTablet, setNavbarTablet] = useState(false);
    const [navbarMobile, setNavbarMobile] = useState(false);
    const [stepUltraLabs, setStepUltraLabs] = useState(false);
    const [playing, setPlaying] = useState(false);
    const [clickMore, setClickMore] = useState(false);
    const { primary } = block;

    let video_thumbnail;
    let videoId = primary.video_link
        .match(/youtube\.com\/.*(\?v=|\/embed\/)(.{11})/)
        ?.pop();

    if (videoId?.length == 11) {
        video_thumbnail = `https://img.youtube.com/vi/${videoId}/0.jpg`;
    } else {
        video_thumbnail = primary.thumbnail.url;
    }

    const [activeTab, setActiveTab] = useState(0);
    const [isTransitioning, setIsTransitioning] = useState(false);

    const handleTabClick = (tabIndex) => {
        if (!isTransitioning) {
            setIsTransitioning(true);
            setTimeout(() => {
                setActiveTab(tabIndex);
                setIsTransitioning(false);
            }, 500); // Transition duration + a small delay
        }
    };

    const openModal = () => {
        setPlaying(true);
        document.body.style.overflow = 'hidden'; // Prevent scrolling
    };

    const closeModal = () => {
        setPlaying(false);
        document.body.style.overflow = 'auto'; // Enable scrolling
    };

    const handleNavbar = () => {
        if (window.scrollY >= 603) {
            setNavbar(true);
        } else {
            setNavbar(false);
        }
    };

    const handleNavbarMobile = () => {
        if (window.scrollY >= 333) {
            setNavbarMobile(true);
        } else {
            setNavbarMobile(false);
        }
    };
    const handleNavbarTablet = () => {
        if (window.scrollY >= 433) {
            setNavbarTablet(true);
        } else {
            setNavbarTablet(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleNavbar);

        return () => window.removeEventListener('scroll', handleNavbar);
    }, []);

    useEffect(() => {
        window.addEventListener('scroll', handleNavbarMobile);

        return () => window.removeEventListener('scroll', handleNavbarMobile);
    }, []);
    useEffect(() => {
        window.addEventListener('scroll', handleNavbarTablet);

        return () => window.removeEventListener('scroll', handleNavbarTablet);
    }, []);


    const widthSize = useScreenWidth(); 4
    const customStyles = {
        content: {
            top: widthSize <= 500 ? '50%' : '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            transform: 'translate(-50%, -50%)',
            padding: widthSize <= 500 ? '15px 10px' : '15px 20px',
            width: widthSize <= 500 ? '100%' : '80%',
            height: widthSize <= 500 ? '55%' : '90%',
            background: '#3c3c3c',
            border: '1px solid #3c3c3c',
            overflow: 'hidden'
        },
    };

    return (
        <>
            <div className={`fade pc-model-wrapper wrapper ${isTransitioning ? '' : 'show'}`}>
                <div
                    className={`pc-model-config-container ${navbar ? 'sticky-container-desktop' : ''
                        } ${navbarTablet ? 'sticky-container-tablet' : ''} ${navbarMobile ? 'sticky-container-mobile' : ''
                        }`}
                    style={stepUltraLabs ? { marginTop: '50px' } : {}}
                >

                    <div className='ultralabs-video-dekstop'>
                        <div className='video-container'>
                            <div className='video-section' onClick={openModal}>
                                <img draggable="false" src={video_thumbnail} width={'100%'} height={'134%'} alt='thumbnail' />
                                <img draggable="false" src='https://cdn.shopify.com/s/files/1/0522/3320/7988/files/circled_play_black.png?v=1713964173' className='circled-play-white' style={{ position: 'absolute' }} alt="icon-play" />
                            </div>
                            <div className='description-section'>
                                <p className='header'>{primary.header}</p>
                                <p className='description'>{primary.description1}</p>
                                <div className='watch-video-container'>
                                    <div className='watch-btn-con'>
                                        <img draggable="false" src='https://cdn.shopify.com/s/files/1/0522/3320/7988/files/circled_play_black.png?v=1713964173' className='circled-play' alt="icon-play" />
                                        <span className='watch-video' onClick={openModal}>WATCH VIDEO</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className='ultralabs-video-mobile'>
                        <div className='video-section-mobile'>
                            <div className='video-container-mobile' onClick={() => setClickMore(!clickMore)}>
                                <img draggable="false" src={video_thumbnail} width={'100%'} height={'134%'} alt='thumbnail' />
                                <img draggable="false" src='https://cdn.shopify.com/s/files/1/0522/3320/7988/files/circled_play_black.png?v=1713964173' className='circled-play-mobile' style={{ position: 'absolute' }} alt="icon-play" />
                            </div>

                            <div className='description-container-mobile'>
                                <p className='header-mobile'>{primary.header}</p>
                                <a className='click-more' onClick={() => setClickMore(!clickMore)}>Click to learn more</a>
                            </div>

                            <div className="toggle-icon-con" onClick={() => setClickMore(!clickMore)}>
                                <img 
                                    draggable="false" 
                                    src={!clickMore ? 
                                        'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/ChevronDown.svg?v=1713890140' 
                                        : 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/ChevronUp.svg?v=1713890188'} 
                                    className='toggle-icon' 
                                />
                            </div>
                        </div>

                        <div className='description-section-mobile' style={clickMore ? { 'display': 'flex' } : { 'display': 'none' }}>
                            <p className='description-mobile'>{primary.description1}</p>

                            <div className='watch-video-container'>
                                <div className='watch-btn-con'>
                                    <img draggable="false" src='https://cdn.shopify.com/s/files/1/0522/3320/7988/files/circled_play_black.png?v=1713964173' className='circled-play' />
                                    <span className='watch-video' onClick={openModal}>WATCH VIDEO</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <Modal
                            style={customStyles}
                            isOpen={playing}
                            contentLabel="Minimal Modal Example"
                            onRequestClose={closeModal}
                        >
                            <button className='modal-btn-close' onClick={closeModal}>{widthSize <= 500 ? 'x' : 'Close'}</button>
                            <p className='modal-header'>{primary.header}</p>
                            <div className='ultralabs-video-container'>
                                <ReactPlayer
                                    className='react-player'
                                    url={primary.video_link}
                                    playing={playing}
                                    width='100%'
                                    height='100%'
                                    controls
                                />
                            </div>
                        </Modal>
                    </div>

                </div>
            </div>
            <style jsx>{styles}</style>
            <style jsx>{global}</style>
        </>
    );
};

export default UltralabsVideo;